// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22MIo","colBig":"styles_colBig__5yk-W","colSmall":"styles_colSmall__3X15c"};